export default __webpack_public_path__ + "static/sign-52c02fa9b294172363319454192fc129.jpg";